import { get, put, Delete, post } from "../axios";

// 审核列表-列表
export const manageList = (params) => get(`/web/examine/manage/list`, params);

// 审核列表-单个审核
export const manageAudi = (params) => put(`/web/examine/manage/audi`, params);

// 审核列表-批量审核
export const batchAudi = (params) =>
  put(`/web/examine/manage/batch/audi`, params);

// 我提交的审核-列表
export const commitList = (params) => get(`/web/examine/commit/list`, params);

// 我提交的审核-详情
export const examineiManageView = (params) =>
  get(`/web/examine/manage/view/` + params, "");
